import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {cs, i18n} from 'utils/index';
import * as Actions from '../actions';
import Styles from '../index.scss';
import {Button, Feedback, Form, Field, Input} from '@alife/aisc';
import {Section, Grid, Select, Search} from '@alife/aisc';
import api from 'utils/fetch';
import tools from 'utils';

const Toast = Feedback.toast;


const {Row, Col} = Grid;

const emailSuffix = [
  'qq.com',
  '163.com',
  '126.com',
  'gmail.com',
  'aliyun.com',
  'alibaba-inc.com',
]

const WARNING_FLAG = 'warning';
const TIP_FLAG = 'tip';
const NONE_FLAG = 'none';

const REFER_PROFILE_SETTING = 'profileSetting'

class BindEmailPanel extends Component {

  constructor() {
    super();
    this.field = new Field(this);
    this.state = {
      comboBoxDataSource: [],
      comboBoxValue: '',
      warningOrTipFlag: NONE_FLAG,
      part2Visible: false,
      emailInputFocus: false,
      lastTargetEmail: null,
      searchButtonText: i18n('发送验证邮件', 'Send Validate Email'),
      allowSearchButtonClick: true,
      resetSecondRemain: 0,
      inputVerificationCode: null,
      isVerificationCodeError: false,
      refer: 'UC',
    }
  }

  componentDidMount() {
    if (tools.getQueryString('refer')) {
      this.setState({
        refer: tools.getQueryString('refer')
      })
    }
  }

  componentDidUpdate() {
    if (!this.state.allowSearchButtonClick) {
      $('.search-input button')[0].setAttribute("disabled", "true");
    } else {
      $('.search-input button')[0].removeAttribute("disabled");
    }
  }

  checkEmailInput = (inputEmail) => {
    if (/^.+@.+\..+$/.test(inputEmail)) {
      return true;
    }
    return false;
  }

  onInputUpdate = (value) => {
    let options;

    if (!value || value.indexOf('@') > 0) {
    } else {
      options = emailSuffix.map(mail => {
        return {
          label: value + '@' + mail,
          value: value + '@' + mail,
          disabled: false,
        };
      });
    }

    this.setState({
      comboBoxDataSource: options,
      comboBoxValue: value
    });
  }

  onSearchButtonClick = (value) => {
    this.setState({
      comboBoxDataSource: null,
      comboBoxValue: value.key
    });

    if (!this.checkEmailInput(this.state.comboBoxValue)) {
      if (!this.state.emailInputFocus) {
        this.setState({
          warningOrTipFlag: WARNING_FLAG
        });
      }
      return;
    }

    setTimeout(() => {
      if (this.state.emailInputFocus) {
        return;
      }

      api.fetch({
        api: 'ucSendValidationEmail',
        data: {
          uuid: tools.getQueryString('uuid'),
          inputEmail: value.key,
          _csrf: window._csrf
        }
      }).then(() => {
        this.setState({
          allowSearchButtonClick: false,
          warningOrTipFlag: TIP_FLAG,
          part2Visible: true,
          lastTargetEmail: value.key,
          resetSecondRemain: 60,
        });

        this.timer = setInterval(() => {
          let count = this.state.resetSecondRemain;
          count -= 1;
          this.setState({
            resetSecondRemain: count,
            searchButtonText: i18n(`${count} 重新发送`, `${count} Resend`),
          });
          if (count < 1) {
            this.setState({
              allowSearchButtonClick: true,
              searchButtonText: i18n(`重新发送`, `Resend`),
            });
            clearInterval(this.timer);
          }
        }, 1000);
      });
    }, 300);
  }


  onEmailInputBlur = () => {
    this.setState({
      emailInputFocus: false
    });
    if (!this.checkEmailInput(this.state.comboBoxValue)) {
      this.setState({
        warningOrTipFlag: WARNING_FLAG
      });
    } else {
      this.setState({
        warningOrTipFlag: NONE_FLAG
      });
    }
  }

  onEmailInputFocus = () => {
    this.setState({
      emailInputFocus: true
    });
    if (this.state.warningOrTipFlag === WARNING_FLAG) {
      this.setState({
        warningOrTipFlag: NONE_FLAG
      });
    }
  }

  onValidationCodeInputChange = (inputVerificationCode) => {
    this.setState({
      inputVerificationCode: inputVerificationCode,
      isVerificationCodeError: false
    });
  }

  onSubmitButtonClick = () => {
    if (this.state.comboBoxValue !== this.state.lastTargetEmail) {
      this.setState({
        isVerificationCodeError: true
      });
      return;
    }
    api.fetch({
      api: 'updateEmailWithValidationCode',
      data: {
        uuid: tools.getQueryString('uuid'),
        inputEmail: this.state.comboBoxValue,
        inputValidationCode: this.state.inputVerificationCode,
        _csrf: window._csrf
      }
    }).then((data) => {
      if (!data.result) {
        this.setState({
          isVerificationCodeError: true
        });
        return;
      }
      const content = this.state.refer === REFER_PROFILE_SETTING ?
        i18n('修改成功，即将返回个人设置', 'Update successfully, auto jumping...') : i18n('绑定成功，即将进入云效', 'Bind successfully, auto jumping')
      Toast.success({
        content: content,
        duration: 3000
      });
      setTimeout(() => {
        window.location.href = tools.getQueryString('from') + '?uuid=' + tools.getQueryString('uuid') + '&ticket=' + tools.getQueryString('ticket') + '&ctx=' + tools.getQueryString('ctx');
      }, 3000);
    });
  }

  onGotoMailboxButtonClick = () => {
    window.open(`http://mail.${this.state.comboBoxValue.match(/@(.*)/)[1]}`);
  }

  render() {
    return (
      <div className={Styles.backgroundWhite}>
        <Row>
          <Col offset="4" span="16">
            <div className={Styles.background}>
              <img className={Styles.centerImage} src={require('../../../images/company-create-2.png')}/>
              <div
                className={Styles.centerTip}>{
                this.state.refer === REFER_PROFILE_SETTING ?
                  i18n('请输入您的新邮箱', 'Please enter your new email address.')
                  :
                  i18n('您的账号暂未绑定邮箱，请绑定后使用', 'Please bind your email to this account.')}</div>

              <Row>
                <Col className={Styles.companyNameInputWrap} offset="5" span="14">

                  <Search
                    placeholder={i18n('请输入您的工作邮箱', 'Enter your email address')}
                    onChange={this.onInputUpdate}
                    searchText={this.state.searchButtonText}
                    onSearch={this.onSearchButtonClick}
                    searchIcon={false}
                    dataSource={this.state.comboBoxDataSource}
                    className={cs(Styles.emailInput, 'search-input')}
                    autoWidth
                    onInputBlur={this.onEmailInputBlur}
                    onInputFocus={this.onEmailInputFocus}
                  />

                  <div style={{
                    marginTop: '10px',
                    marginBottom: '0px',
                    height: '30px'
                  }}>
                    {this.state.warningOrTipFlag === WARNING_FLAG &&
                    <div style={{
                      color: 'red'
                    }}>{i18n('请正确输入邮箱地址', 'Please enter your email correctly')}</div>}
                    {this.state.warningOrTipFlag === TIP_FLAG &&
                    <div>{i18n('验证码已经发送到您的邮箱，马上去验证。', 'Send validation code successfully.')}
                      <Button
                        onClick={this.onGotoMailboxButtonClick}
                        shape="text" size="small">{i18n('登录邮箱', 'Go to check.')}</Button></div>}
                  </div>

                  {this.state.part2Visible && <div>
                    <Input
                      state={this.state.isVerificationCodeError ? 'error' : null}
                      onChange={this.onValidationCodeInputChange}
                      placeholder={i18n('请输入您收到的验证码', 'Enter the validation code')}
                      className={Styles.validationCodeInput}
                      maxLength={6}/>
                    <div style={{
                      marginTop: '10px',
                      marginBottom: '0px',
                      height: '30px'
                    }}>
                      {this.state.isVerificationCodeError &&
                      <div style={{color: 'red'}}>{i18n('请正确输入验证码', 'Please input verification code correctly')}</div>}
                    </div>
                    <Button style={{
                      width: '100%',
                    }} type="primary"
                            onClick={this.onSubmitButtonClick}>{
                      this.state.refer === REFER_PROFILE_SETTING ?
                        i18n('完成修改', 'Submit')
                        :
                        i18n('立即开启', 'Start a new journey')}</Button>
                  </div>}

                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    list: state.get('list'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BindEmailPanel);




/** WEBPACK FOOTER **
 ** ./src/pages/ucBindEmail/containers/bindEmailPanel.jsx
 **/